var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 49.14 53.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 38.27,
    y1: 13.25,
    x2: 49.14,
    y2: 13.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d70a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e1790"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 13.26,
    x2: 10.88,
    y2: 13.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.23,
    y1: 26.8,
    x2: 46.91,
    y2: 26.8,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.13,3a1.68,1.68,0,0,0-2.37,2.37,23.86,23.86,0,0,1,7,17,1.68,1.68,0,0,0,3.35,0A27.18,27.18,0,0,0,41.13,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.35,22.34a23.86,23.86,0,0,1,7-17A1.68,1.68,0,0,0,8,3,27.22,27.22,0,0,0,0,22.34a1.68,1.68,0,0,0,3.35,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.52,40a14.93,14.93,0,0,1-5.31-11.45V22.34a15.66,15.66,0,0,0-14-15.55V1.68a1.68,1.68,0,1,0-3.35,0V6.79a15.67,15.67,0,0,0-14,15.55v6.22A15,15,0,0,1,3.6,40a3.91,3.91,0,0,0,2.54,6.88H16.36a8.38,8.38,0,0,0,16.42,0H43A3.91,3.91,0,0,0,45.52,40Zm-21,10.25a5,5,0,0,1-4.74-3.35h9.48A5,5,0,0,1,24.57,50.26ZM43,43.56H6.14a.56.56,0,0,1-.35-1,18.31,18.31,0,0,0,6.5-14V22.34a12.29,12.29,0,1,1,24.57,0v6.22a18.31,18.31,0,0,0,6.5,14,.6.6,0,0,1,.2.43A.57.57,0,0,1,43,43.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.eb62ca7fb2ce926e328e8a7c0a9a7dd7.svg";
export { ForwardRef as ReactComponent };